<section class="table__header">
	<ng-content select="app-table-header-group"/>
</section>
<section class="table__data">
	<ng-content select="app-table-data-group"/>
</section>
